// extracted by mini-css-extract-plugin
export default {"wrap":"fcdbac5c97f5","header":"bc3a3c62ca3d","businessProfileName":"d8797e9c7fe0","summaryCell":"ac6cd6ad662b","summaryHeader":"f676f11daea6","supportInfo":"f5bb668cd9b0"};